/**
 * The display language for a saved choice and the browser's language tags:
 * the saved choice if supported, else the exact tag, Chinese by script or
 * region, Portuguese → pt-BR, then the base language; null when none match.
 *
 * Self-contained on purpose (no imports, no syntax newer than ES2017): the
 * build inlines this function's source into index.html, so the dictionary
 * can be preloaded before the app's code arrives (build/localePreload.ts).
 */
export function pickLocale(saved: string | null, tags: readonly string[], supported: readonly string[]): string | null {
  if (saved && supported.indexOf(saved) !== -1) return saved;
  for (let index = 0; index < tags.length; index++) {
    let parts: string[];
    try {
      const canonical = Intl.getCanonicalLocales(tags[index])[0];
      parts = canonical ? canonical.split("-") : [];
    } catch (error) {
      continue;
    }
    const language = parts[0] || "";
    const subtags = parts.slice(1);
    const exact = parts.join("-");
    if (supported.indexOf(exact) !== -1) return exact;
    if (language === "zh") {
      if (subtags.indexOf("Hans") !== -1) return "zh-CN";
      return subtags.some((subtag) => ["Hant", "TW", "HK", "MO"].indexOf(subtag) !== -1) ? "zh-TW" : "zh-CN";
    }
    if (language === "pt") return "pt-BR";
    if (supported.indexOf(language) !== -1) return language;
  }
  return null;
}
